import React from "react"

import { Footer } from "../compositions"
// import { useAuth } from "../../hooks"

type Props = {
  children: JSX.Element | JSX.Element[]
}

function Frame({ children }: Props) {
  // const { auth } = useAuth()

  return (
    <div className="relative min-width-80">
      <main className="relative z-10">{children}</main>
      <Footer className="relative z-0"></Footer>
    </div>
  )
}

export default Frame
